import {
  type BillingRunMonthlyListDto,
  type DistributionInstructionSummaryDetail,
  type InstructionWithCurrencyConversions,
  type MonthlyBillingRunSummaryDetail,
  type PaymentConfirmedDistributionsSummary
} from '../../api-schema-types/asset-holdings/DistributionInstructionDomainDtos'

 
export function distributionInstructionApiMapper () {
  const billingRunSummariesMapper = (
    responseData: BillingRunMonthlyListDto[],
    responseMeta: any,
    responseArgs: any
  ): BillingRunMonthlyListDto[] => {
    return responseData
  }

  const paymentConfirmedSummariesMapper = (
    responseData: PaymentConfirmedDistributionsSummary,
    responseMeta: any,
    responseArgs: any
  ): PaymentConfirmedDistributionsSummary => {
    return responseData
  }

  const billingRunSummaryDetailMapper = (
    responseData: MonthlyBillingRunSummaryDetail,
    responseMeta: any,
    responseArgs: any
  ): MonthlyBillingRunSummaryDetail => {
    return responseData
  }

  const assetHolderDistributionInstructionsMapper = (
    responseData: DistributionInstructionSummaryDetail,
    responseMeta: any,
    responseArgs: any
  ): DistributionInstructionSummaryDetail => {
    return responseData
  }

  const distributionInstructionSummaryMapper = (
    responseData: InstructionWithCurrencyConversions[],
    responseMeta: any,
    responseArgs: any
  ): InstructionWithCurrencyConversions[] => {
    return responseData
  }

  return {
    billingRunSummariesMapper, paymentConfirmedSummariesMapper, distributionInstructionsMapper: billingRunSummaryDetailMapper, distributionInstructionSummaryMapper, assetHolderDistributionInstructionsMapper
  }
}
